import { css } from 'linaria';

export const styledModal = css`
  && {
    user-select: none;
  }
`;

export const curtainMobileModal = css`
  && {
    @media (width <= 375px) {
      && {
        border-radius: unset;
      }
    }
  }
`;

export const modalHeader = css`
  padding: 40px 64px 16px 40px;

  @media (width <= 375px) {
    padding: 16px 48px 16px 16px;
  }
`;

export const modalHeaderTitle = css`
  @media (width <= 375px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const mobileHeaderTitle = css`
  @media (width <= 375px) {
    display: none;
  }
`;

export const mobileModalHeaderTitle = css`
  display: none;

  @media (width <= 375px) {
    display: block;
  }
`;

export const modalContentAction = css`
  padding: 40px 0;
  margin-top: auto;

  @media (width <= 375px) {
    min-height: 80px;
    padding: 16px 0;
  }
`;

export const modalContent = css`
  margin-bottom: 40px;

  @media () {
    margin-bottom: 32px;
  }
`;

export const modalContentContainer = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;
